import { useEntityCalculations } from './useEntityCalculations';
import type { RentalProduct } from '@/types/entities';
import type { RentalKit } from '@/types/entities/rental-kit';

interface UseRentalCalculationsProps {
  inventoryItems: Pick<RentalProduct, 'id' | 'dailyPrice' | 'hourlyPrice'>[];
  kits: Pick<RentalKit, 'id' | 'price'>[];
  selectedKitIds: string[];
  startDate?: Date;
  endDate?: Date;
  discount?: number;
  tariffType?: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'custom'; // Тип тарифа
}

export function useRentalCalculations({
  inventoryItems,
  kits,
  selectedKitIds,
  startDate,
  endDate,
  discount = 0,
  tariffType,
}: UseRentalCalculationsProps) {
  // Преобразуем данные в формат useEntityCalculations
  const entityInventoryItems = inventoryItems.map(item => ({
    id: item.id,
    dailyPrice: item.dailyPrice,
    hourlyPrice: item.hourlyPrice
  }));

  const entityKits = kits.map(kit => ({
    id: kit.id,
    price: kit.price
  }));

  // Используем унифицированный хук расчетов
  const { totalAmount, breakdown } = useEntityCalculations({
    startDate,
    endDate,
    inventoryItems: entityInventoryItems,
    selectedInventoryItems: inventoryItems.map(item => ({ id: item.id, quantity: 1 })), // для аренды quantity всегда 1
    kits: entityKits,
    selectedKitIds,
    discount,
    mode: 'rental', // только аренда, без покупки товаров
    tariffType, // передаем тип тарифа
  });

  return { 
    totalAmount,
    breakdown // дополнительная детализация расчетов
  };
}
